import { configureStore } from '@reduxjs/toolkit';
import counterSlice from './allreducer';
const store = configureStore({
  reducer: {
    // Your reducers go here
    counter: counterSlice
  },
});

export default store;

/// web-font-api-key: AIzaSyBsfznUhp3w6XAMEfFphAaH5gT8nT1uqUw